// extracted by mini-css-extract-plugin
export default {"Hamburger":"HamburgerMenu_Hamburger__f-q5q","Active":"HamburgerMenu_Active__mtNC9"};